import { makeRequest } from 'utils/requestLogger';

export default (submissionID) =>
    makeRequest('put', `/api/submissions/${submissionID}/teacher-unflag`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/unflagSubmission.js